import { useState, useRef, MutableRefObject } from 'react';
import mapboxgl from 'mapbox-gl';

type PopupInfo = {
  id: string;
  property_id: string;
  latitude: number;
  longitude: number;
} | null;

type UsePropertyPopupReturn = {
  popupInfo: PopupInfo;
  popupHeight: number;
  popupLoading: boolean;
  openPopup: (info: PopupInfo) => void;
  closePopup: () => void;
  setPopupHeight: (height: number) => void;
  setPopupLoading: (loading: boolean) => void;
  markerRef: mapboxgl.Marker | null;
  markersRef: MutableRefObject<Record<string, mapboxgl.Marker>>;
};

export function usePropertyPopup(): UsePropertyPopupReturn {
  const [ popupInfo, setPopupInfo ] = useState<PopupInfo>(null);
  const [ popupHeight, setPopupHeight ] = useState(0);
  const [ popupLoading, setPopupLoading ] = useState(false);
  const markersRef = useRef<Record<string, mapboxgl.Marker>>({});

  const openPopup = (info: PopupInfo) => {
    console.log('openPopup', info);
    setPopupInfo(info);
    setPopupHeight(0); // Reset for new popup
  };

  const closePopup = () => {
    console.log('closePopup');
    setPopupInfo(null);
    setPopupHeight(0);
  };

  const markerRef = popupInfo ? markersRef.current[popupInfo.id] : null;

  return {
    popupInfo,
    popupHeight,
    popupLoading,
    openPopup,
    closePopup,
    setPopupHeight,
    setPopupLoading,
    markerRef,
    markersRef,
  };
}
